import axios from "axios";

const isLocal = process.env.REACT_APP_ENV?.trimEnd() === "LOCAL";
const axiosInstance = axios.create({
    baseURL: isLocal
        ? (process.env.REACT_APP_API_URL_LOCAL || "http://localhost:5000/api/v1")
        : (process.env.REACT_APP_API_URL || "https://api.jugglerewards.app/api/v1/"),
});

axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("accessToken");
        if (token) {
            config.headers["authorization"] = "Bearer " + token; // for Spring Boot back-end
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    (res) => {
        return res;
    },
    async (err) => {
        const originalConfig = err.config;

        if (originalConfig.url !== "api/v1/login" && err.response) {
            // Access Token was expired
            if (err.response.status === 401) {
                localStorage.removeItem("accessToken");
                window.location.reload();
            }
        }

        return Promise.reject(err);
    }
);
export default axiosInstance;
